import React from "react";
import { Grid } from "@material-ui/core";

interface SimpleGridItemProps {
  title: string;
  value?: string | string[];
  valueElem?: JSX.Element[];
  size?: 2 | 3 | 4 | 6 | 8 | 12;
}
export default function SimpleGridItem(props: SimpleGridItemProps) {
  const { title, value, size } = props;
  return (
    <Grid item xs={12} md={size || 12}>
      <span className="detail-item-heading">{title}: </span>{" "}
      <span className="detail-item-content">{value}</span>
    </Grid>
  );
}
